import { Box, Divider, Switch, Typography } from '@mui/material';
import React, { useCallback, useId } from 'react';

interface IProps {
  title: string;
  description: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  dataAction?: string;
}

export const DeactivateSection: React.FC<IProps> = ({
  title,
  description,
  checked,
  onChange,
  disabled,
  dataAction,
}) => {
  const titleId = useId();

  const handleChange = useCallback(
    (_event: React.ChangeEvent<HTMLInputElement>, next: boolean) => onChange(next),
    [onChange],
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Divider />
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
        <Box sx={{ flex: '1 1 0%', minWidth: 0, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Typography id={titleId} variant="body1">
            {title}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', textWrap: 'pretty' }}>
            {description}
          </Typography>
        </Box>
        <Switch
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          inputProps={
            { 'aria-labelledby': titleId, 'data-action': dataAction } as React.InputHTMLAttributes<HTMLInputElement>
          }
        />
      </Box>
    </Box>
  );
};

export default DeactivateSection;
